define("ember-simple-auth/-internals/routing", ["exports", "ember", "ember-simple-auth/utils/is-fastboot", "ember-simple-auth/utils/location"], function (_exports, _ember, _isFastboot, _location) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.handleSessionAuthenticated = handleSessionAuthenticated;
  _exports.handleSessionInvalidated = handleSessionInvalidated;
  _exports.prohibitAuthentication = prohibitAuthentication;
  _exports.requireAuthentication = requireAuthentication;
  _exports.triggerAuthentication = triggerAuthentication;
  function requireAuthentication(owner, transition) {
    let sessionService = owner.lookup('service:session');
    let isAuthenticated = sessionService.get('isAuthenticated');
    if (!isAuthenticated) {
      if (transition && (0, _isFastboot.default)(owner)) {
        const fastbootService = owner.lookup('service:fastboot');
        const cookiesService = owner.lookup('service:cookies');
        cookiesService.write('ember_simple_auth-redirectTarget', transition.intent.url, {
          path: '/',
          secure: fastbootService.get('request.protocol') === 'https'
        });
      } else if (transition) {
        sessionService.set('attemptedTransition', transition);
      }
    }
    return isAuthenticated;
  }
  function triggerAuthentication(owner, authenticationRoute) {
    let authRouter = owner.lookup('service:router') || owner.lookup('router:main');
    authRouter.transitionTo(authenticationRoute);
  }
  function prohibitAuthentication(owner, routeIfAlreadyAuthenticated) {
    let authRouter = owner.lookup('service:router') || owner.lookup('router:main');
    authRouter.transitionTo(routeIfAlreadyAuthenticated);
  }
  function handleSessionAuthenticated(owner, routeAfterAuthentication) {
    let sessionService = owner.lookup('service:session');
    let attemptedTransition = sessionService.get('attemptedTransition');
    let cookiesService = owner.lookup('service:cookies');
    const redirectTarget = cookiesService.read('ember_simple_auth-redirectTarget');
    let routerService = owner.lookup('service:router');
    if (attemptedTransition) {
      attemptedTransition.retry();
      sessionService.set('attemptedTransition', null);
    } else if (redirectTarget) {
      routerService.transitionTo(redirectTarget);
      cookiesService.clear('ember_simple_auth-redirectTarget');
    } else {
      routerService.transitionTo(routeAfterAuthentication);
    }
  }
  function handleSessionInvalidated(owner, routeAfterInvalidation) {
    if ((0, _isFastboot.default)(owner)) {
      let routerService = owner.lookup('service:router');
      routerService.transitionTo(routeAfterInvalidation);
    } else {
      if (!_ember.default.testing) {
        (0, _location.default)().replace(routeAfterInvalidation);
      }
    }
  }
});